(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
function initOne(root) {
    if (root.__fhInit) return;
    root.__fhInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.fhslider__slide'));
    if (slides.length === 0) return;

    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var timer = null;

    var currentEl = root.querySelector('.fhslider__current');
    var totalEl = root.querySelector('.fhslider__total');
    if (totalEl) totalEl.textContent = slides.length;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (sl, idx) { sl.classList.toggle('is-active', idx === current); });
      if (currentEl) currentEl.textContent = current + 1;
    }
    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() { stop(); if (autoplay && slides.length > 1) timer = setInterval(next, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var nextBtn = root.querySelector('.fhslider__next');
    var prevBtn = root.querySelector('.fhslider__prev');
    var playBtn = root.querySelector('.fhslider__autoplay');
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); start(); });
    if (playBtn) playBtn.addEventListener('click', function (e) {
      e.preventDefault();
      autoplay = !autoplay;
      playBtn.classList.toggle('is-paused', !autoplay);
      if (autoplay) start(); else stop();
    });

    show(0);
    start();
    root.__fhStart = start;
    root.__fhStop = stop;
  }

  function initAll() {
    document.querySelectorAll('[data-fhslider]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.faqBound) return;
    root.dataset.faqBound = '1';
    var allowMultiple = root.dataset.multiple === 'true';
    function closeOthers(except) {
      root.querySelectorAll('.faq__item.is-open').forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var b = it.querySelector('.faq__q'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq__q');
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.faq__item');
      var willOpen = !item.classList.contains('is-open');
      if (willOpen && !allowMultiple) closeOthers(item);
      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-faq]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('.faq__item'); if (!item) return;
    var root = item.closest('[data-faq]');
    if (root && root.dataset.multiple !== 'true') {
      root.querySelectorAll('.faq__item.is-open').forEach(function (it) {
        if (it === item) return;
        it.classList.remove('is-open');
        var b = it.querySelector('.faq__q'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    item.classList.add('is-open');
    var btn = item.querySelector('.faq__q'); if (btn) btn.setAttribute('aria-expanded', 'true');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
